'use client';

import { useState, type ReactNode } from 'react';
import { useEndpointDetections } from './hooks/useEndpointDetections';
import { DetectionsHoverCardPopover } from './DetectionsHoverCardPopover';
import type { DetectionView } from './types';

type DetectionMetricHoverCardProps = {
  type: 'finding' | 'signal';
  endpointId: string;
  detectionView: DetectionView;
  children: ReactNode;
  disabled?: boolean;
  onViewFinding?: (findingId: string) => void;
  onViewSignal?: (signalId: string) => void;
};

export const DetectionMetricHoverCard = ({
  type,
  endpointId,
  detectionView,
  children,
  disabled = false,
  onViewFinding,
  onViewSignal,
}: DetectionMetricHoverCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { findings, signals, isLoading, isError } = useEndpointDetections({
    endpointId,
    enabled: isOpen && !disabled,
  });

  if (disabled) {
    return children;
  }

  return (
    <DetectionsHoverCardPopover
      type={type}
      detectionView={detectionView}
      findings={findings}
      signals={signals}
      isLoading={isLoading}
      isError={isError}
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      onViewFinding={onViewFinding}
      onViewSignal={onViewSignal}
    >
      {children}
    </DetectionsHoverCardPopover>
  );
};
